/**
 * 片区 | 有序充电 | 充电站 | 运营商设置
 */
import Net from '../net';

const NAME = '[OrgStationApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === Org === **/
/** org/create
 * @param {Object} data
 * @param {*} data.org_id
 * @param {*} data.name
 * @param {*} data.operator_id
 * @param {*} data.province
 * @param {*} data.city
 * @param {*} data.county
 * @param {*} data.street
 * @param {*} data.region_code
 * @param {*} data.address
 * @param {*} data.phone
 * @param {*} data.tenement
 * @param {*} data.tenement_contacts
 * @param {*} data.tenement_contacts_phone
 * @param {*} data.charge_config_ids
 * @param {*} data.clearing_config_id
 * @param {*} data.resource_package_config_id
 * @param {*} data.recharge_config_id
 * @param {*} data.recharge_car_config_id
*/
export async function saveOrg(data = {}) {
  Log('saveOrg data:', data)
  try {
    const res = await Net.http('org/create', { data })
    Log('saveOrg res:', res)
    return res
  } catch (err) {
    Log('saveOrg err:', err)
    throw err
  }
}

/** org/delete
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function deleteOrg(data = {}) {
  Log('deleteOrg data:', data)
  try {
    const res = await Net.http('org/delete', { data })
    Log('deleteOrg res:', res)
    return res
  } catch (err) {
    Log('deleteOrg err:', err)
    throw err
  }
}

/** org/detail
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function getOrgDetail(data = {}) {
  Log('getOrgDetail data:', data)
  try {
    const res = await Net.http('org/detail', { data })
    Log('getOrgDetail res:', res)
    return res
  } catch (err) {
    Log('getOrgDetail err:', err)
    throw err
  }
}

/** org/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.sort
 * @param {*} data.sub_operator_id
*/
export async function getOrgList(data = {}) {
  Log('getOrgList data:', data)
  try {
    const res = await Net.http('org/list', { data })
    Log('getOrgList res:', res)
    return res
  } catch (err) {
    Log('getOrgList err:', err)
    throw err
  }
}

/** org/list-all
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.status
*/
export async function getOrgListAll(data = {}) {
  Log('getOrgListAll data:', data)
  try {
    const res = await Net.http('org/list-all', { data })
    Log('getOrgListAll res:', res)
    return res
  } catch (err) {
    Log('getOrgListAll err:', err)
    throw err
  }
}

/** org/list-name
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.status
*/
export async function getOrgListName(data = {}) {
  Log('getOrgListName data:', data)
  try {
    const res = await Net.http('org/list-name', { data })
    Log('getOrgListName res:', res)
    return res
  } catch (err) {
    Log('getOrgListName err:', err)
    throw err
  }
}

/** org/list
 * @param {Object} data
 * @param {*} data.page_size
 * @param {*} data.name
 * @param {*} data.operator_id
*/
export async function getOrgListByName(data = {}) {
  Log('getOrgListByName data:', data)
  try {
    const res = await Net.http('org/list', { data })
    Log('getOrgListByName res:', res)
    return res
  } catch (err) {
    Log('getOrgListByName err:', err)
    throw err
  }
}

/** org/recover-org-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.status
 * @param {*} data.operator_id
 * @param {*} data.name
*/
export async function orgRecycleList(data = {}) {
  Log('orgRecycleList data:', data)
  try {
    const res = await Net.http('org/recover-org-list', { data })
    Log('orgRecycleList res:', res)
    return res
  } catch (err) {
    Log('orgRecycleList err:', err)
    throw err
  }
}

/** org/recover-org
 * @param {Object} data
 * @param {*} data.status
 * @param {*} data.org_ids
*/
export async function orgRecycle(data = {}) {
  Log('orgRecycle data:', data)
  try {
    const res = await Net.http('org/recover-org', { data })
    Log('orgRecycle res:', res)
    return res
  } catch (err) {
    Log('orgRecycle err:', err)
    throw err
  }
}

/** org/batch-delete
 * @param {Object} data
 * @param {*} data.org_ids
*/
export async function batchDeleteOrg(data = {}) {
  Log('batchDeleteOrg data:', data)
  try {
    const res = await Net.http('org/batch-delete', { data })
    Log('batchDeleteOrg res:', res)
    return res
  } catch (err) {
    Log('batchDeleteOrg err:', err)
    throw err
  }
}

/** org/update-org-operator
 * @param {Object} data
 * @param {*} data.org_id
 * @param {*} data.operator_id
*/
export async function changeOrgOperator(data = {}) {
  Log('changeOrgOperator data:', data)
  try {
    const res = await Net.http('org/update-org-operator', { data })
    Log('changeOrgOperator res:', res)
    return res
  } catch (err) {
    Log('changeOrgOperator err:', err)
    throw err
  }
}

/** org/get-org-charge-config
 * @param {Object} data
 * @param {*} data.id
*/
export async function getOrgChargeConfig(data = {}) {
  Log('getOrgChargeConfig data:', data)
  try {
    const res = await Net.http('org/get-org-charge-config', { data })
    Log('getOrgChargeConfig res:', res)
    return res
  } catch (err) {
    Log('getOrgChargeConfig err:', err)
    throw err
  }
}

/** org/set-org-charge-config
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.charge_config_id
*/
export async function setOrgChargeConfig(data = {}) {
  Log('setOrgChargeConfig data:', data)
  try {
    const res = await Net.http('org/set-org-charge-config', { data })
    Log('setOrgChargeConfig res:', res)
    return res
  } catch (err) {
    Log('setOrgChargeConfig err:', err)
    throw err
  }
}

/** org/update-org-charge-config
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.target_charge_config_id
 * @param {*} data.row_charge_config_id
*/
export async function updateOrgChargeConfig(data = {}) {
  Log('updateOrgChargeConfig data:', data)
  try {
    const res = await Net.http('org/update-org-charge-config', { data })
    Log('updateOrgChargeConfig res:', res)
    return res
  } catch (err) {
    Log('updateOrgChargeConfig err:', err)
    throw err
  }
}

/** org/set-pre-charge-charge-config
 * @param {Object} data
 * @param {*} data.org_id
 * @param {*} data.operator_config_id
 * @param {*} data.flag_pre_charge
 * @param {*} data.pre_charge_reserve_time
 * @param {*} data.flag_pre_charge_charge
 * @param {*} data.pre_charge_config_id
*/
export async function setOrgPreChargeChargeConfig(data = {}) {
  Log('setOrgPreChargeChargeConfig data:', data)
  try {
    const res = await Net.http('org/set-pre-charge-charge-config', { data })
    Log('setOrgPreChargeChargeConfig res:', res)
    return res
  } catch (err) {
    Log('setOrgPreChargeChargeConfig err:', err)
    throw err
  }
}

/** org/org-all-card-count
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function getOrgAllCardCount(data = {}) {
  Log('getOrgAllCardCount data:', data)
  try {
    const res = await Net.http('org/org-all-card-count', { data })
    Log('getOrgAllCardCount res:', res)
    return res
  } catch (err) {
    Log('getOrgAllCardCount err:', err)
    throw err
  }
}

/** org/list-unbind-by-recharge-clearing-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.recharge_config_id
 * @param {*} data.org_name
*/
export async function getOrgUnbindByRechargeConfig(data = {}) {
  Log('getOrgUnbindByRechargeConfig data:', data)
  try {
    const res = await Net.http('org/list-unbind-by-recharge-clearing-config', { data })
    Log('getOrgUnbindByRechargeConfig res:', res)
    return res
  } catch (err) {
    Log('getOrgUnbindByRechargeConfig err:', err)
    throw err
  }
}

/** org/list-unbind-by-charge-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.charge_config_id
 * @param {*} data.org_name
*/
export async function getOrgUnbindByChargeConfig(data = {}) {
  Log('getOrgUnbindByChargeConfig data:', data)
  try {
    const res = await Net.http('org/list-unbind-by-charge-config', { data })
    Log('getOrgUnbindByChargeConfig res:', res)
    return res
  } catch (err) {
    Log('getOrgUnbindByChargeConfig err:', err)
    throw err
  }
}

/** org/get-open-station-flag-member-price-count
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function getOrgOpenFlagMemberPriceCount(data = {}) {
  Log('getOrgOpenFlagMemberPriceCount data:', data)
  try {
    const res = await Net.http('org/get-open-station-flag-member-price-count', { data })
    Log('getOrgOpenFlagMemberPriceCount res:', res)
    return res
  } catch (err) {
    Log('getOrgOpenFlagMemberPriceCount err:', err)
    throw err
  }
}

/** org/close-station-flag-member-price
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function closeOrgStationFlagMemberPrice(data = {}) {
  Log('closeOrgStationFlagMemberPrice data:', data)
  try {
    const res = await Net.http('org/close-station-flag-member-price', { data })
    Log('closeOrgStationFlagMemberPrice res:', res)
    return res
  } catch (err) {
    Log('closeOrgStationFlagMemberPrice err:', err)
    throw err
  }
}


/** === OrgPowerDirect === **/
/** org-power-direct/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.org_id
 * @param {*} data.config
*/
export async function saveOrgPowerDirect(data = {}) {
  Log('saveOrgPowerDirect data:', data)
  try {
    const res = await Net.http('org-power-direct/save', { data })
    Log('saveOrgPowerDirect res:', res)
    return res
  } catch (err) {
    Log('saveOrgPowerDirect err:', err)
    throw err
  }
}

/** org-power-direct/detail
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function getOrgPowerDirectDetail(data = {}) {
  Log('getOrgPowerDirectDetail data:', data)
  try {
    const res = await Net.http('org-power-direct/detail', { data })
    Log('getOrgPowerDirectDetail res:', res)
    return res
  } catch (err) {
    Log('getOrgPowerDirectDetail err:', err)
    throw err
  }
}

/** org-power-direct/pool-set
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function orgPowerDirectPoolSet(data = {}) {
  Log('orgPowerDirectPoolSet data:', data)
  try {
    const res = await Net.http('org-power-direct/pool-set', { data })
    Log('orgPowerDirectPoolSet res:', res)
    return res
  } catch (err) {
    Log('orgPowerDirectPoolSet err:', err)
    throw err
  }
}

/** org-power-direct/pool-get
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function orgPowerDirectPoolGet(data = {}) {
  Log('orgPowerDirectPoolGet data:', data)
  try {
    const res = await Net.http('org-power-direct/pool-get', { data })
    Log('orgPowerDirectPoolGet res:', res)
    return res
  } catch (err) {
    Log('orgPowerDirectPoolGet err:', err)
    throw err
  }
}

/** org-power-direct/list
 * @param {Object} data
 * @param {*} data.name
 * @param {*} data.org_id
 * @param {*} data.operator_id
 * @param {*} data.page
*/
export async function getOrgPowerDirectList(data = {}) {
  Log('getOrgPowerDirectList data:', data)
  try {
    const res = await Net.http('org-power-direct/list', { data })
    Log('getOrgPowerDirectList res:', res)
    return res
  } catch (err) {
    Log('getOrgPowerDirectList err:', err)
    throw err
  }
}

/** org-power-direct/power-direct-log-list
 * @param {Object} data
 * @param {*} data.org_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.page
 * @param {*} data.page_size
*/
export async function orgPowerDirectPowerDirectLogList(data = {}) {
  Log('orgPowerDirectPowerDirectLogList data:', data)
  try {
    const res = await Net.http('org-power-direct/power-direct-log-list', { data })
    Log('orgPowerDirectPowerDirectLogList res:', res)
    return res
  } catch (err) {
    Log('orgPowerDirectPowerDirectLogList err:', err)
    throw err
  }
}

/** org-power-direct/set-charge-config
 * @param {Object} data
 * @param {*} data.org_id
 * @param {*} data.flag_independent_charge
 * @param {*} data.charge_config_id
*/
export async function setOrgPowerDirectChargeConfig(data = {}) {
  Log('setOrgPowerDirectChargeConfig data:', data)
  try {
    const res = await Net.http('org-power-direct/set-charge-config', { data })
    Log('setOrgPowerDirectChargeConfig res:', res)
    return res
  } catch (err) {
    Log('setOrgPowerDirectChargeConfig err:', err)
    throw err
  }
}

/** org-power-direct/pool-node-set
 * @param {Object} data
 * @param {*} data.org_id
 * @param {*} data.suid
 * @param {*} data.max_power
 * @param {*} data.min_power
 * @param {*} data.max_step_power
*/
export async function orgPowerDirectPoolNodeSet(data = {}) {
  Log('orgPowerDirectPoolNodeSet data:', data)
  try {
    const res = await Net.http('org-power-direct/pool-node-set', { data })
    Log('orgPowerDirectPoolNodeSet res:', res)
    return res
  } catch (err) {
    Log('orgPowerDirectPoolNodeSet err:', err)
    throw err
  }
}

/** org-power-direct/get-sensor-data
 * @param {Object} data
 * @param {*} data.device_id
*/
export async function getOrgPowerDirectSensorData(data = {}) {
  Log('getOrgPowerDirectSensorData data:', data)
  try {
    const res = await Net.http('org-power-direct/get-sensor-data', { data })
    Log('getOrgPowerDirectSensorData res:', res)
    return res
  } catch (err) {
    Log('getOrgPowerDirectSensorData err:', err)
    throw err
  }
}


/** === Station === **/
/** station/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.name
 * @param {*} data.sort
 * @param {*} data.gateway_id
 * @param {*} data.is_off
 * @param {*} data.device_type
 * @param {*} data.type
 * @param {*} data.flag_auto_close
 * @param {*} data.flag_parking_discount
*/
export async function getStationList(data = {}) {
  Log('getStationList data:', data)
  try {
    const res = await Net.http('station/list', { data })
    Log('getStationList res:', res)
    return res
  } catch (err) {
    Log('getStationList err:', err)
    throw err
  }
}

/** station/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.org_id
*/
export async function getStationListByOrgId(data = {}) {
  Log('getStationListByOrgId data:', data)
  try {
    const res = await Net.http('station/list', { data })
    Log('getStationListByOrgId res:', res)
    return res
  } catch (err) {
    Log('getStationListByOrgId err:', err)
    throw err
  }
}

/** station/all-list
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function getStationListAll(data = {}) {
  Log('getStationListAll data:', data)
  try {
    const res = await Net.http('station/all-list', { data })
    Log('getStationListAll res:', res)
    return res
  } catch (err) {
    Log('getStationListAll err:', err)
    throw err
  }
}

/** station/all-list-simple
 * @param {Object} data
*/
export async function getStationListAllSimple(data = {}) {
  Log('getStationListAllSimple data:', data)
  try {
    const res = await Net.http('station/all-list-simple', { data })
    Log('getStationListAllSimple res:', res)
    return res
  } catch (err) {
    Log('getStationListAllSimple err:', err)
    throw err
  }
}

/** station/list
 * @param {Object} data
 * @param {*} data.page_size
 * @param {*} data.name
 * @param {*} data.operator_id
*/
export async function getStationListByName(data = {}) {
  Log('getStationListByName data:', data)
  try {
    const res = await Net.http('station/list', { data })
    Log('getStationListByName res:', res)
    return res
  } catch (err) {
    Log('getStationListByName err:', err)
    throw err
  }
}

/** station/create
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.province
 * @param {*} data.city
 * @param {*} data.county
 * @param {*} data.address
 * @param {*} data.longitude
 * @param {*} data.latitude
 * @param {*} data.type
 * @param {*} data.device_type
 * @param {*} data.gateway_id
 * @param {*} data.org_id
*/
export async function createStation(data = {}) {
  Log('createStation data:', data)
  try {
    const res = await Net.http('station/create', { data })
    Log('createStation res:', res)
    return res
  } catch (err) {
    Log('createStation err:', err)
    throw err
  }
}

/** station/create-by-operator
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.province
 * @param {*} data.city
 * @param {*} data.county
 * @param {*} data.address
 * @param {*} data.longitude
 * @param {*} data.latitude
 * @param {*} data.type
 * @param {*} data.device_type
 * @param {*} data.gateway_id
 * @param {*} data.org_id
*/
export async function createStationByOperator(data = {}) {
  Log('createStationByOperator data:', data)
  try {
    const res = await Net.http('station/create-by-operator', { data })
    Log('createStationByOperator res:', res)
    return res
  } catch (err) {
    Log('createStationByOperator err:', err)
    throw err
  }
}

/** station/update
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.province
 * @param {*} data.city
 * @param {*} data.county
 * @param {*} data.address
 * @param {*} data.longitude
 * @param {*} data.latitude
 * @param {*} data.type
 * @param {*} data.device_type
 * @param {*} data.gateway_id
 * @param {*} data.org_id
 * @param {*} data.charge_config_id
 * @param {*} data.clearing_config_id
*/
export async function updateStation(data = {}) {
  Log('updateStation data:', data)
  try {
    const res = await Net.http('station/update', { data })
    Log('updateStation res:', res)
    return res
  } catch (err) {
    Log('updateStation err:', err)
    throw err
  }
}

/** station/off-list
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.page
*/
export async function stationOffList(data = {}) {
  Log('stationOffList data:', data)
  try {
    const res = await Net.http('station/off-list', { data })
    Log('stationOffList res:', res)
    return res
  } catch (err) {
    Log('stationOffList err:', err)
    throw err
  }
}

/** station/check-list
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.page
*/
export async function checkStationList(data = {}) {
  Log('checkStationList data:', data)
  try {
    const res = await Net.http('station/check-list', { data })
    Log('checkStationList res:', res)
    return res
  } catch (err) {
    Log('checkStationList err:', err)
    throw err
  }
}

/** station/check
 * @param {Object} data
 * @param {*} data.station_id
 * @param {*} data.status
*/
export async function checkStation(data = {}) {
  Log('checkStation data:', data)
  try {
    const res = await Net.http('station/check', { data })
    Log('checkStation res:', res)
    return res
  } catch (err) {
    Log('checkStation err:', err)
    throw err
  }
}

/** station/recover-station-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.status
 * @param {*} data.operator_id
 * @param {*} data.org_ids
 * @param {*} data.name
*/
export async function stationRecycleList(data = {}) {
  Log('stationRecycleList data:', data)
  try {
    const res = await Net.http('station/recover-station-list', { data })
    Log('stationRecycleList res:', res)
    return res
  } catch (err) {
    Log('stationRecycleList err:', err)
    throw err
  }
}

/** station/recover-station
 * @param {Object} data
 * @param {*} data.status
 * @param {*} data.ids
*/
export async function stationRecycle(data = {}) {
  Log('stationRecycle data:', data)
  try {
    const res = await Net.http('station/recover-station', { data })
    Log('stationRecycle res:', res)
    return res
  } catch (err) {
    Log('stationRecycle err:', err)
    throw err
  }
}

/** station/detail
 * @param {Object} data
 * @param {*} data.station_id
*/
export async function getStationDetail(data = {}) {
  Log('getStationDetail data:', data)
  try {
    const res = await Net.http('station/detail', { data })
    Log('getStationDetail res:', res)
    return res
  } catch (err) {
    Log('getStationDetail err:', err)
    throw err
  }
}

/** station/allot
 * @param {Object} data
 * @param {*} data.station_ids
 * @param {*} data.operator_id
 * @param {*} data.org_id
*/
export async function stationAllot(data = {}) {
  Log('stationAllot data:', data)
  try {
    const res = await Net.http('station/allot', { data })
    Log('stationAllot res:', res)
    return res
  } catch (err) {
    Log('stationAllot err:', err)
    throw err
  }
}

/** station/delete
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.station_id
*/
export async function deleteStation(data = {}) {
  Log('deleteStation data:', data)
  try {
    const res = await Net.http('station/delete', { data })
    Log('deleteStation res:', res)
    return res
  } catch (err) {
    Log('deleteStation err:', err)
    throw err
  }
}

/** station/batch-delete
 * @param {Object} data
 * @param {*} data.station_ids
*/
export async function batchDeleteStation(data = {}) {
  Log('batchDeleteStation data:', data)
  try {
    const res = await Net.http('station/batch-delete', { data })
    Log('batchDeleteStation res:', res)
    return res
  } catch (err) {
    Log('batchDeleteStation err:', err)
    throw err
  }
}

/** station/set-station-auto-close
 * @param {Object} data
 * @param {*} data.station_id
*/
export async function setStationQuantifiable(data = {}) {
  Log('setStationQuantifiable data:', data)
  try {
    const res = await Net.http('station/set-station-auto-close', { data })
    Log('setStationQuantifiable res:', res)
    return res
  } catch (err) {
    Log('setStationQuantifiable err:', err)
    throw err
  }
}

/** station/batch-set-station-auto-close
 * @param {Object} data
 * @param {*} data.station_ids
*/
export async function stationBatchSetQuantifiable(data = {}) {
  Log('stationBatchSetQuantifiable data:', data)
  try {
    const res = await Net.http('station/batch-set-station-auto-close', { data })
    Log('stationBatchSetQuantifiable res:', res)
    return res
  } catch (err) {
    Log('stationBatchSetQuantifiable err:', err)
    throw err
  }
}

/** station/check-by-gatewayId
 * @param {Object} data
 * @param {*} data.gateway_id
*/
export async function checkStationGatewayId(data = {}) {
  Log('checkStationGatewayId data:', data)
  try {
    const res = await Net.http('station/check-by-gatewayId', { data })
    Log('checkStationGatewayId res:', res)
    return res
  } catch (err) {
    Log('checkStationGatewayId err:', err)
    throw err
  }
}

/** station/check-gateway
 * @param {Object} data
 * @param {*} data.gateway_id
*/
export async function checkStationGatewayByAdmin(data = {}) {
  Log('checkStationGatewayByAdmin data:', data)
  try {
    const res = await Net.http('station/check-gateway', { data })
    Log('checkStationGatewayByAdmin res:', res)
    return res
  } catch (err) {
    Log('checkStationGatewayByAdmin err:', err)
    throw err
  }
}

/** station/set-station-service-fee-charge-config-decimal
 * @param {Object} data
 * @param {*} data.station_id
*/
export async function setStationChargeConfigDecimal(data = {}) {
  Log('setStationChargeConfigDecimal data:', data)
  try {
    const res = await Net.http('station/set-station-service-fee-charge-config-decimal', { data })
    Log('setStationChargeConfigDecimal res:', res)
    return res
  } catch (err) {
    Log('setStationChargeConfigDecimal err:', err)
    throw err
  }
}

/** station/set-station-gd
 * @param {Object} data
 * @param {*} data.station_id
*/
export async function setStationGaode(data = {}) {
  Log('setStationGaode data:', data)
  try {
    const res = await Net.http('station/set-station-gd', { data })
    Log('setStationGaode res:', res)
    return res
  } catch (err) {
    Log('setStationGaode err:', err)
    throw err
  }
}

/** station/set-station-halo
 * @param {Object} data
 * @param {*} data.station_id
*/
export async function setStationHaluo(data = {}) {
  Log('setStationHaluo data:', data)
  try {
    const res = await Net.http('station/set-station-halo', { data })
    Log('setStationHaluo res:', res)
    return res
  } catch (err) {
    Log('setStationHaluo err:', err)
    throw err
  }
}

/** station/batch-set-station-halo
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.flag
*/
export async function stationBatchSetHaluo(data = {}) {
  Log('stationBatchSetHaluo data:', data)
  try {
    const res = await Net.http('station/batch-set-station-halo', { data })
    Log('stationBatchSetHaluo res:', res)
    return res
  } catch (err) {
    Log('stationBatchSetHaluo err:', err)
    throw err
  }
}

/** station/set-station-discount-parking
 * @param {Object} data
 * @param {*} data.station_id
*/
export async function stationParkingStart(data = {}) {
  Log('stationParkingStart data:', data)
  try {
    const res = await Net.http('station/set-station-discount-parking', { data })
    Log('stationParkingStart res:', res)
    return res
  } catch (err) {
    Log('stationParkingStart err:', err)
    throw err
  }
}

/** station/set-station-discount-parking-config
 * @param {Object} data
 * @param {*} data.station_id
 * @param {*} data.config
*/
export async function stationParkingConfig(data = {}) {
  Log('stationParkingConfig data:', data)
  try {
    const res = await Net.http('station/set-station-discount-parking-config', { data })
    Log('stationParkingConfig res:', res)
    return res
  } catch (err) {
    Log('stationParkingConfig err:', err)
    throw err
  }
}

/** station/list-unbind-by-charge-config
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.charge_config_id
 * @param {*} data.station_name
*/
export async function getStationUnbindByChargeConfig(data = {}) {
  Log('getStationUnbindByChargeConfig data:', data)
  try {
    const res = await Net.http('station/list-unbind-by-charge-config', { data })
    Log('getStationUnbindByChargeConfig res:', res)
    return res
  } catch (err) {
    Log('getStationUnbindByChargeConfig err:', err)
    throw err
  }
}

/** export-task/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.type
 * @param {*} data.status
*/
export async function exportStationList(data = {}) {
  Log('exportStationList data:', data)
  try {
    const res = await Net.http('export-task/list', { data })
    Log('exportStationList res:', res)
    return res
  } catch (err) {
    Log('exportStationList err:', err)
    throw err
  }
}

/** export-task/create-station-export
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
*/
export async function exportStation(data = {}) {
  Log('exportStation data:', data)
  try {
    const res = await Net.http('export-task/create-station-export', { data })
    Log('exportStation res:', res)
    return res
  } catch (err) {
    Log('exportStation err:', err)
    throw err
  }
}


/** === OperatorConfig === **/
/** operator-config/detail
 * @param {Object} data
 * @param {*} data.org_id
*/
export async function getOperatorConfigDetailByOrgId(data = {}) {
  Log('getOperatorConfigDetailByOrgId data:', data)
  try {
    const res = await Net.http('operator-config/detail', { data })
    Log('getOperatorConfigDetailByOrgId res:', res)
    return res
  } catch (err) {
    Log('getOperatorConfigDetailByOrgId err:', err)
    throw err
  }
}

/** operator-config/detail
 * @param {Object} data
 * @param {*} data.station_id
*/
export async function getOperatorConfigDetailByStationId(data = {}) {
  Log('getOperatorConfigDetailByStationId data:', data)
  try {
    const res = await Net.http('operator-config/detail', { data })
    Log('getOperatorConfigDetailByStationId res:', res)
    return res
  } catch (err) {
    Log('getOperatorConfigDetailByStationId err:', err)
    throw err
  }
}

/** operator-config/set-enable-ad
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.org_id
 * @param {*} data.flag_ad
*/
export async function operatorConfigFlagAd(data = {}) {
  Log('operatorConfigFlagAd data:', data)
  try {
    const res = await Net.http('operator-config/set-enable-ad', { data })
    Log('operatorConfigFlagAd res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFlagAd err:', err)
    throw err
  }
}

/** operator-config/set-flag-ad-after-pay
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.org_id
 * @param {*} data.flag_ad_after_pay
*/
export async function operatorConfigFlagAdAfterPay(data = {}) {
  Log('operatorConfigFlagAdAfterPay data:', data)
  try {
    const res = await Net.http('operator-config/set-flag-ad-after-pay', { data })
    Log('operatorConfigFlagAdAfterPay res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFlagAdAfterPay err:', err)
    throw err
  }
}

/** operator-config/set-station-independent-config
 * @param {Object} data
 * @param {*} data.station_id
*/
export async function setOperatorConfigStationIndependentConfig(data = {}) {
  Log('setOperatorConfigStationIndependentConfig data:', data)
  try {
    const res = await Net.http('operator-config/set-station-independent-config', { data })
    Log('setOperatorConfigStationIndependentConfig res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigStationIndependentConfig err:', err)
    throw err
  }
}

/** operator-config/set-enable-qrcode
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigQrcodeEnable(data = {}) {
  Log('operatorConfigQrcodeEnable data:', data)
  try {
    const res = await Net.http('operator-config/set-enable-qrcode', { data })
    Log('operatorConfigQrcodeEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigQrcodeEnable err:', err)
    throw err
  }
}

/** operator-config/set-qrcode-enable
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigQrcodeEnableAll(data = {}) {
  Log('operatorConfigQrcodeEnableAll data:', data)
  try {
    const res = await Net.http('operator-config/set-qrcode-enable', { data })
    Log('operatorConfigQrcodeEnableAll res:', res)
    return res
  } catch (err) {
    Log('operatorConfigQrcodeEnableAll err:', err)
    throw err
  }
}

/** operator-config/enable-wx
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigWxEnable(data = {}) {
  Log('operatorConfigWxEnable data:', data)
  try {
    const res = await Net.http('operator-config/enable-wx', { data })
    Log('operatorConfigWxEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigWxEnable err:', err)
    throw err
  }
}

/** operator-config/enable-alipay
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigAlipayEnable(data = {}) {
  Log('operatorConfigAlipayEnable data:', data)
  try {
    const res = await Net.http('operator-config/enable-alipay', { data })
    Log('operatorConfigAlipayEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigAlipayEnable err:', err)
    throw err
  }
}

/** operator-config/enable-wx-pay-score
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigWxPayScoreEnable(data = {}) {
  Log('operatorConfigWxPayScoreEnable data:', data)
  try {
    const res = await Net.http('operator-config/enable-wx-pay-score', { data })
    Log('operatorConfigWxPayScoreEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigWxPayScoreEnable err:', err)
    throw err
  }
}

/** operator-config/set-bf-pay
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigFlagBfPay(data = {}) {
  Log('operatorConfigFlagBfPay data:', data)
  try {
    const res = await Net.http('operator-config/set-bf-pay', { data })
    Log('operatorConfigFlagBfPay res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFlagBfPay err:', err)
    throw err
  }
}

/** operator-config/set-enable-virtual-card
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigVirtualCardEnable(data = {}) {
  Log('operatorConfigVirtualCardEnable data:', data)
  try {
    const res = await Net.http('operator-config/set-enable-virtual-card', { data })
    Log('operatorConfigVirtualCardEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigVirtualCardEnable err:', err)
    throw err
  }
}

/** operator-config/set-enable-virtual-package-card
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigVirtualPackageCardEnable(data = {}) {
  Log('operatorConfigVirtualPackageCardEnable data:', data)
  try {
    const res = await Net.http('operator-config/set-enable-virtual-package-card', { data })
    Log('operatorConfigVirtualPackageCardEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigVirtualPackageCardEnable err:', err)
    throw err
  }
}

/** operator-config/set-pay-message
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.pay_message
*/
export async function operatorConfigPayMessage(data = {}) {
  Log('operatorConfigPayMessage data:', data)
  try {
    const res = await Net.http('operator-config/set-pay-message', { data })
    Log('operatorConfigPayMessage res:', res)
    return res
  } catch (err) {
    Log('operatorConfigPayMessage err:', err)
    throw err
  }
}

/** operator-config/set-card-multiple-order
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigFlagCardMultipleOrder(data = {}) {
  Log('operatorConfigFlagCardMultipleOrder data:', data)
  try {
    const res = await Net.http('operator-config/set-card-multiple-order', { data })
    Log('operatorConfigFlagCardMultipleOrder res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFlagCardMultipleOrder err:', err)
    throw err
  }
}

/** operator-config/set-package-card-multiple-order
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigFlagPackageCardMultipleOrder(data = {}) {
  Log('operatorConfigFlagPackageCardMultipleOrder data:', data)
  try {
    const res = await Net.http('operator-config/set-package-card-multiple-order', { data })
    Log('operatorConfigFlagPackageCardMultipleOrder res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFlagPackageCardMultipleOrder err:', err)
    throw err
  }
}

/** operator-config/set-virtual-package-card-multiple-order
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigFlagVirtualCardMultipleOrder(data = {}) {
  Log('operatorConfigFlagVirtualCardMultipleOrder data:', data)
  try {
    const res = await Net.http('operator-config/set-virtual-package-card-multiple-order', { data })
    Log('operatorConfigFlagVirtualCardMultipleOrder res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFlagVirtualCardMultipleOrder err:', err)
    throw err
  }
}

/** operator-config/set-recharge-enable
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigRechargeEnable(data = {}) {
  Log('operatorConfigRechargeEnable data:', data)
  try {
    const res = await Net.http('operator-config/set-recharge-enable', { data })
    Log('operatorConfigRechargeEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigRechargeEnable err:', err)
    throw err
  }
}

/** operator-config/enable-card-charge
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigCardChargeEnable(data = {}) {
  Log('operatorConfigCardChargeEnable data:', data)
  try {
    const res = await Net.http('operator-config/enable-card-charge', { data })
    Log('operatorConfigCardChargeEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigCardChargeEnable err:', err)
    throw err
  }
}

/** operator-config/enable-package-card-charge
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigPackageCardChargeEnable(data = {}) {
  Log('operatorConfigPackageCardChargeEnable data:', data)
  try {
    const res = await Net.http('operator-config/enable-package-card-charge', { data })
    Log('operatorConfigPackageCardChargeEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigPackageCardChargeEnable err:', err)
    throw err
  }
}

/** operator-config/enable-virtual-card-charge
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigVirtualCardChargeEnable(data = {}) {
  Log('operatorConfigVirtualCardChargeEnable data:', data)
  try {
    const res = await Net.http('operator-config/enable-virtual-card-charge', { data })
    Log('operatorConfigVirtualCardChargeEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigVirtualCardChargeEnable err:', err)
    throw err
  }
}

/** operator-config/enable-virtual-package-card-charge
 * @param {Object} data
 * @param {*} data.operator_config_id
*/
export async function operatorConfigVirtualPackageCardChargeEnable(data = {}) {
  Log('operatorConfigVirtualPackageCardChargeEnable data:', data)
  try {
    const res = await Net.http('operator-config/enable-virtual-package-card-charge', { data })
    Log('operatorConfigVirtualPackageCardChargeEnable res:', res)
    return res
  } catch (err) {
    Log('operatorConfigVirtualPackageCardChargeEnable err:', err)
    throw err
  }
}

/** operator-config/bind-charge-config-id
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.charge_config_id
*/
export async function bindOperatorConfigCharge(data = {}) {
  Log('bindOperatorConfigCharge data:', data)
  try {
    const res = await Net.http('operator-config/bind-charge-config-id', { data })
    Log('bindOperatorConfigCharge res:', res)
    return res
  } catch (err) {
    Log('bindOperatorConfigCharge err:', err)
    throw err
  }
}

/** operator-config/bind-clearing-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.clearing_config_id
*/
export async function bindOperatorConfigChargeSettle(data = {}) {
  Log('bindOperatorConfigChargeSettle data:', data)
  try {
    const res = await Net.http('operator-config/bind-clearing-config', { data })
    Log('bindOperatorConfigChargeSettle res:', res)
    return res
  } catch (err) {
    Log('bindOperatorConfigChargeSettle err:', err)
    throw err
  }
}

/** operator-config/bind-recharge-clearing-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.clearing_config_id
*/
export async function bindOperatorConfigCardSettle(data = {}) {
  Log('bindOperatorConfigCardSettle data:', data)
  try {
    const res = await Net.http('operator-config/bind-recharge-clearing-config', { data })
    Log('bindOperatorConfigCardSettle res:', res)
    return res
  } catch (err) {
    Log('bindOperatorConfigCardSettle err:', err)
    throw err
  }
}

/** operator-config/bind-resource-package-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.resource_package_config_id
*/
export async function bindOperatorConfigTime(data = {}) {
  Log('bindOperatorConfigTime data:', data)
  try {
    const res = await Net.http('operator-config/bind-resource-package-config', { data })
    Log('bindOperatorConfigTime res:', res)
    return res
  } catch (err) {
    Log('bindOperatorConfigTime err:', err)
    throw err
  }
}

/** operator-config/bind-recharge-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.recharge_config_id
 * @param {*} data.recharge_config_mode
 * @param {*} data.recharge_config_start_time
 * @param {*} data.recharge_config_finish_time
*/
export async function bindOperatorConfigMoneyPlug(data = {}) {
  Log('bindOperatorConfigMoneyPlug data:', data)
  try {
    const res = await Net.http('operator-config/bind-recharge-config', { data })
    Log('bindOperatorConfigMoneyPlug res:', res)
    return res
  } catch (err) {
    Log('bindOperatorConfigMoneyPlug err:', err)
    throw err
  }
}

/** operator-config/bind-car-recharge-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.recharge_config_id
 * @param {*} data.recharge_car_config_mode
 * @param {*} data.recharge_car_config_start_time
 * @param {*} data.recharge_car_config_finish_time
*/
export async function bindOperatorConfigMoneyCar(data = {}) {
  Log('bindOperatorConfigMoneyCar data:', data)
  try {
    const res = await Net.http('operator-config/bind-car-recharge-config', { data })
    Log('bindOperatorConfigMoneyCar res:', res)
    return res
  } catch (err) {
    Log('bindOperatorConfigMoneyCar err:', err)
    throw err
  }
}

/** operator-config/unbind-recharge-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.recharge_config_id
*/
export async function unbindOperatorConfigRechargeConfig(data = {}) {
  Log('unbindOperatorConfigRechargeConfig data:', data)
  try {
    const res = await Net.http('operator-config/unbind-recharge-config', { data })
    Log('unbindOperatorConfigRechargeConfig res:', res)
    return res
  } catch (err) {
    Log('unbindOperatorConfigRechargeConfig err:', err)
    throw err
  }
}

/** operator-config/recharge-config-batch-bind-org
 * @param {Object} data
 * @param {*} data.recharge_config_id
 * @param {*} data.operator_config_ids
*/
export async function operatorConfigRechargeBatchBindOrg(data = {}) {
  Log('operatorConfigRechargeBatchBindOrg data:', data)
  try {
    const res = await Net.http('operator-config/recharge-config-batch-bind-org', { data })
    Log('operatorConfigRechargeBatchBindOrg res:', res)
    return res
  } catch (err) {
    Log('operatorConfigRechargeBatchBindOrg err:', err)
    throw err
  }
}

/** org/batch-bind-org-charge-config
 * @param {Object} data
 * @param {*} data.charge_config_id
 * @param {*} data.org_ids
*/
export async function operatorConfigChargeBatchBindOrg(data = {}) {
  Log('operatorConfigChargeBatchBindOrg data:', data)
  try {
    const res = await Net.http('org/batch-bind-org-charge-config', { data })
    Log('operatorConfigChargeBatchBindOrg res:', res)
    return res
  } catch (err) {
    Log('operatorConfigChargeBatchBindOrg err:', err)
    throw err
  }
}

/** operator-config/batch-bind-charge-config
 * @param {Object} data
 * @param {*} data.charge_config_id
 * @param {*} data.station_ids
*/
export async function operatorConfigChargeBatchBindStation(data = {}) {
  Log('operatorConfigChargeBatchBindStation data:', data)
  try {
    const res = await Net.http('operator-config/batch-bind-charge-config', { data })
    Log('operatorConfigChargeBatchBindStation res:', res)
    return res
  } catch (err) {
    Log('operatorConfigChargeBatchBindStation err:', err)
    throw err
  }
}

/** operator-config/auto-refund-qrcode
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.auto_refund_qrcode
 * @param {*} data.auto_refund_min_money_qrcode
*/
export async function operatorConfigRefundQrcode(data = {}) {
  Log('operatorConfigRefundQrcode data:', data)
  try {
    const res = await Net.http('operator-config/auto-refund-qrcode', { data })
    Log('operatorConfigRefundQrcode res:', res)
    return res
  } catch (err) {
    Log('operatorConfigRefundQrcode err:', err)
    throw err
  }
}

/** operator-config/set-auto-refund-mini-money-card
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.auto_refund_card
 * @param {*} data.auto_refund_min_money_card
*/
export async function operatorConfigRefundCard(data = {}) {
  Log('operatorConfigRefundCard data:', data)
  try {
    const res = await Net.http('operator-config/set-auto-refund-mini-money-card', { data })
    Log('operatorConfigRefundCard res:', res)
    return res
  } catch (err) {
    Log('operatorConfigRefundCard err:', err)
    throw err
  }
}

/** operator-config/auto-refund-virtual-card
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.auto_refund_virtual_card
 * @param {*} data.auto_refund_min_money_virtual_card
*/
export async function operatorConfigRefundVirtualCard(data = {}) {
  Log('operatorConfigRefundVirtualCard data:', data)
  try {
    const res = await Net.http('operator-config/auto-refund-virtual-card', { data })
    Log('operatorConfigRefundVirtualCard res:', res)
    return res
  } catch (err) {
    Log('operatorConfigRefundVirtualCard err:', err)
    throw err
  }
}

/** operator-config/set-free-low-energy
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_enable
 * @param {*} data.free_low_energy_threshold
*/
export async function operatorConfigFreeLowEnergy(data = {}) {
  Log('operatorConfigFreeLowEnergy data:', data)
  try {
    const res = await Net.http('operator-config/set-free-low-energy', { data })
    Log('operatorConfigFreeLowEnergy res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFreeLowEnergy err:', err)
    throw err
  }
}

/** operator-config/set-free-low-power
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_enable
 * @param {*} data.free_low_power_threshold
*/
export async function operatorConfigFreeLowPower(data = {}) {
  Log('operatorConfigFreeLowPower data:', data)
  try {
    const res = await Net.http('operator-config/set-free-low-power', { data })
    Log('operatorConfigFreeLowPower res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFreeLowPower err:', err)
    throw err
  }
}

/** operator-config/set-free-charge-time
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.is_enable
 * @param {*} data.free_charge_time
*/
export async function operatorConfigFreeChargeTime(data = {}) {
  Log('operatorConfigFreeChargeTime data:', data)
  try {
    const res = await Net.http('operator-config/set-free-charge-time', { data })
    Log('operatorConfigFreeChargeTime res:', res)
    return res
  } catch (err) {
    Log('operatorConfigFreeChargeTime err:', err)
    throw err
  }
}

/** operator-config/set-over-charge-close-order
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_enable
 * @param {*} data.power_threshold
 * @param {*} data.power_duration
 * @param {*} data.zero_power_report_count
*/
export async function operatorConfigChargeFullClose(data = {}) {
  Log('operatorConfigChargeFullClose data:', data)
  try {
    const res = await Net.http('operator-config/set-over-charge-close-order', { data })
    Log('operatorConfigChargeFullClose res:', res)
    return res
  } catch (err) {
    Log('operatorConfigChargeFullClose err:', err)
    throw err
  }
}

/** operator-config/set-electric-charge
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.is_enable
 * @param {*} data.energy_price
 * @param {*} data.energy_ratio
 * @param {*} data.flag_energy_charge_clearing
 * @param {*} data.energy_charge_clearing_config_id
*/
export async function setOperatorConfigElectricCharge(data = {}) {
  Log('setOperatorConfigElectricCharge data:', data)
  try {
    const res = await Net.http('operator-config/set-electric-charge', { data })
    Log('setOperatorConfigElectricCharge res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigElectricCharge err:', err)
    throw err
  }
}

/** operator-config/set-disable-charge
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_enable
 * @param {*} data.disable_charge_mode
 * @param {*} data.disable_charge_begin_time
 * @param {*} data.disable_charge_end_time
*/
export async function setOperatorConfigDisableCharge(data = {}) {
  Log('setOperatorConfigDisableCharge data:', data)
  try {
    const res = await Net.http('operator-config/set-disable-charge', { data })
    Log('setOperatorConfigDisableCharge res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigDisableCharge err:', err)
    throw err
  }
}

/** operator-config/update-charge-full-enable
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.charge_full_enable
 * @param {*} data.charge_full_money
 * @param {*} data.charge_full_money_min
*/
export async function operatorConfigChargeFull(data = {}) {
  Log('operatorConfigChargeFull data:', data)
  try {
    const res = await Net.http('operator-config/update-charge-full-enable', { data })
    Log('operatorConfigChargeFull res:', res)
    return res
  } catch (err) {
    Log('operatorConfigChargeFull err:', err)
    throw err
  }
}

/** operator-config/set-voice-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_voice
 * @param {*} data.config
*/
export async function setOperatorConfigVoiceConfig(data = {}) {
  Log('setOperatorConfigVoiceConfig data:', data)
  try {
    const res = await Net.http('operator-config/set-voice-config', { data })
    Log('setOperatorConfigVoiceConfig res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigVoiceConfig err:', err)
    throw err
  }
}

/** operator-config/set-invoice
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_invoice
*/
export async function setOperatorConfigInvoice(data = {}) {
  Log('setOperatorConfigInvoice data:', data)
  try {
    const res = await Net.http('operator-config/set-invoice', { data })
    Log('setOperatorConfigInvoice res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigInvoice err:', err)
    throw err
  }
}

/** operator-config/set-occupy-charge-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_car_occupy_after_charge
 * @param {*} data.occupy_charge_config_id
*/
export async function setOperatorConfigOccupyChargeConfig(data = {}) {
  Log('setOperatorConfigOccupyChargeConfig data:', data)
  try {
    const res = await Net.http('operator-config/set-occupy-charge-config', { data })
    Log('setOperatorConfigOccupyChargeConfig res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigOccupyChargeConfig err:', err)
    throw err
  }
}

/** operator-config/set-member-price-config
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.is_enable
 * @param {*} data.member_price_config
*/
export async function setOperatorConfigMemberPriceConfig(data = {}) {
  Log('setOperatorConfigMemberPriceConfig data:', data)
  try {
    const res = await Net.http('operator-config/set-member-price-config', { data })
    Log('setOperatorConfigMemberPriceConfig res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigMemberPriceConfig err:', err)
    throw err
  }
}

/** operator-config/set-flag-user-apply-refund
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_user_apply_refund
*/
export async function setOperatorConfigRefundApplication(data = {}) {
  Log('setOperatorConfigRefundApplication data:', data)
  try {
    const res = await Net.http('operator-config/set-flag-user-apply-refund', { data })
    Log('setOperatorConfigRefundApplication res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigRefundApplication err:', err)
    throw err
  }
}

/** operator-config/set-flag-vin-charge
 * @param {Object} data
 * @param {*} data.operator_config_id
 * @param {*} data.flag_vin_charge
*/
export async function setOperatorConfigFlagVinCharge(data = {}) {
  Log('setOperatorConfigFlagVinCharge data:', data)
  try {
    const res = await Net.http('operator-config/set-flag-vin-charge', { data })
    Log('setOperatorConfigFlagVinCharge res:', res)
    return res
  } catch (err) {
    Log('setOperatorConfigFlagVinCharge err:', err)
    throw err
  }
}
